import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileStickyBar from "../components/MobileStickyBar";
import Seo from "../components/Seo";
import { COMPANY } from "../lib/site";
import { useLang } from "../i18n/LanguageContext";

export default function Contact() {
  const { t } = useLang();
  return (
    <div className="min-h-screen">
      <Seo title={`${t("nav.contact")} | ${COMPANY.name}`} description={t("contact.desc")} path="/kontakt" />
      <Header />
      <section className="section">
        <div className="container-page grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <span className="eyebrow">{t("contact.eyebrow")}</span>
            <h1 className="mt-2 font-display text-4xl sm:text-5xl font-bold">{t("contact.title")}</h1>
            <div className="dot-divider mt-4" />
            <p className="mt-5 text-[#383E45]">{t("contact.desc")}</p>
            <div className="mt-8 space-y-4">
              <a href={`tel:${COMPANY.phoneClean}`} className="flex items-center gap-4 rounded-xl border border-[#E2DDD5] bg-white p-4 hover:border-[#1B3626]" data-testid="contact-call">
                <span className="w-11 h-11 rounded-md bg-[#1B3626] text-white grid place-items-center"><Phone size={18}/></span>
                <div><div className="font-display font-bold">{COMPANY.phone}</div><div className="text-sm text-[#555E68]">{t("contact.callUs")}</div></div>
              </a>
              <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-4 rounded-xl border border-[#E2DDD5] bg-white p-4 hover:border-[#1B3626]" data-testid="contact-email">
                <span className="w-11 h-11 rounded-md bg-[#1B3626] text-white grid place-items-center"><Mail size={18}/></span>
                <div><div className="font-display font-bold break-all">{COMPANY.email}</div><div className="text-sm text-[#555E68]">{t("contact.sendEmail")}</div></div>
              </a>
              <div className="flex items-center gap-4 rounded-xl border border-[#E2DDD5] bg-white p-4">
                <span className="w-11 h-11 rounded-md bg-[#1B3626] text-white grid place-items-center"><MapPin size={18}/></span>
                <div><div className="font-display font-bold">{COMPANY.area}</div><div className="text-sm text-[#555E68]">{t("contact.areaDesc")}</div></div>
              </div>
            </div>
          </div>
          <div className="lg:col-span-7">
            <div className="rounded-xl overflow-hidden border border-[#E2DDD5] bg-white">
              <iframe title={t("contact.mapLabel")} src="https://www.google.com/maps?q=Halden%2C%20Norway&z=11&output=embed" width="100%" height="500" style={{ border: 0 }} loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            </div>
          </div>
        </div>
      </section>
      <Footer /><MobileStickyBar />
    </div>
  );
}
